<div class="chat-footer-bar">
  @for (window of _chatWindowService.tabbedWindows(); track window.id) {
    <button
      type="button"
      class="footer-btn tab"
      [class.tab--active]="window.state === 'open'"
      (click)="_onTabClick(window.id)"
    >
      @if (window.state === 'minimized' && window.status !== 'idle') {
        <span
          class="tab-hint"
          [class.tab-hint--processing]="window.status === 'processing'"
          [class.tab-hint--unread]="window.status === 'unread'"
          [class.tab-hint--question]="window.status === 'question'"
          [title]="_hintLabel(window.status)"
        ></span>
      }
      <span class="tab-title">{{ window.title }}</span>
      <i
        class="myre-icon-close close-icon"
        (click)="_onTabClose($event, window.id)"
      ></i>
    </button>
  }

  <button type="button" class="footer-btn ask" (click)="_onNewChat()">
    {{ chatWordings.askMyre() }}
  </button>

  <button type="button" class="footer-btn history" (click)="_toggleHistory()">
    <i class="myre-icon-history"></i>
  </button>
</div>

<!-- Dropdown rendered outside the bar so overflow:hidden doesn't clip it -->
@if (_showHistory()) {
  <div class="history-backdrop" (click)="_closeHistory()"></div>
  <div class="history-dropdown">
    @if (_sessionsLoading()) {
      <div class="history-loading">...</div>
    }
    @for (session of _sessions(); track session.id) {
      <div class="history-item">
        @if (_editingSessionId() === session.id) {
          <input
            #renameInput
            type="text"
            class="history-rename-input"
            [value]="_editTitle()"
            (input)="_editTitle.set(renameInput.value)"
            (keydown.enter)="_onRenameSubmit(session)"
            (keydown.escape)="_onRenameCancel()"
          />
          <button
            type="button"
            class="history-action"
            [title]="chatWordings.save()"
            (click)="_onRenameSubmit(session)"
          >
            <i class="myre-icon-check"></i>
          </button>
          <button
            type="button"
            class="history-action"
            [title]="chatWordings.cancel()"
            (click)="_onRenameCancel()"
          >
            <i class="myre-icon-close"></i>
          </button>
        } @else {
          <button
            type="button"
            class="history-open"
            (click)="_onSelectSession(session)"
          >
            <span class="history-title">{{
              session.title || chatWordings.untitledSession()
            }}</span>
            <span class="history-date">{{
              session.updateDate | date: 'short'
            }}</span>
          </button>
          <button
            type="button"
            class="history-action"
            [title]="chatWordings.renameSession()"
            (click)="_onRename($event, session)"
          >
            <i class="myre-icon-edit"></i>
          </button>
          <button
            type="button"
            class="history-action"
            [title]="chatWordings.deleteSession()"
            (click)="_onDelete($event, session)"
          >
            <i class="myre-icon-delete"></i>
          </button>
        }
      </div>
    } @empty {
      @if (!_sessionsLoading()) {
        <div class="history-loading">{{ chatWordings.noHistory() }}</div>
      }
    }
  </div>
}
